<template>
  <div>
    <vs-card>
      <vs-table :data="users">
        <template slot="header">
          <h3>
            Work Status
          </h3>
        </template>
        <template slot="thead">
          <vs-th>Name
          </vs-th>
          <vs-th>Email
          </vs-th>
          <vs-th>Work Order
          </vs-th>
          <vs-th>Due Date
          </vs-th>
          <vs-th>Time Spent
          </vs-th>
          <vs-th>Complete?
          </vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
            <vs-td :data="data[indextr].email">
              {{data[indextr].email}}
            </vs-td>
            <vs-td :data="data[indextr].username">
              {{data[indextr].name}}
            </vs-td>
            <vs-td :data="data[indextr].id">
              {{data[indextr].id}}
            </vs-td>
            <vs-td :data="data[indextr].id">
              {{data[indextr].website}}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-card>
  </div>
</template>

<script>
export default {
  name: 'WorkStatus',
  data: () => ({
    
  }),
  methods: {
    
  }
}
</script>